<!-- gpd-no-inline-validation: this component renders its own inline error (it also re-checks the
     other contract party), so the app-wide one in helpers/inline-validation-errors.ts stays out. -->
<div *ngIf="persons != undefined || companies != undefined" class="contact-dropdown-box-container gpd-no-inline-validation">
  <dx-drop-down-box class="contact-dropdown-box gpd-input" #contactDropDownBox
    [placeholder]="placeholder" [(value)]="contactId" [openOnFieldClick]="true" [acceptCustomValue]="true"
    [(opened)]="isGridBoxOpened" (onInput)="onInput($event)" (onInitialized)="onDropDownBoxInit($event)"
    (onValueChanged)="dropDownBoxValueChanged($event)" [focusStateEnabled]="true" (onOpened)="applyFilters()"
    valueExpr="id" displayExpr="displayName" [readOnly]="readOnly"
    [dataSource]="contactType == 'person' ? persons : contactType == 'society' ? societies : companies" [showClearButton]="true">
    <!-- validationGroup was declared as an @Input and never bound, so the rule joined whatever
         group the DOM gave it rather than the one the caller's save button validates. -->
    <!-- DevExtreme's own tooltip is hidden in the CSS (focus-only, flips above the field when
         the dropdown opens); the message is shown inline below instead, see .gpd-field-error. -->
    <dx-validator *ngIf="validationRequired" [validationGroup]="validationGroup || undefined"
      (onInitialized)="onValidatorInitialized($event)" (onValidated)="onValidated($event)">
      <dxi-validation-rule type="required" [message]="validationMessage"></dxi-validation-rule>
      <dxi-validation-rule *ngIf="contractDuplicateValidation" type="custom"
        [message]="duplicateMessage" [reevaluate]="true"
        [validationCallback]="validateContractContactDuplicate">
      </dxi-validation-rule>
    </dx-validator>
    <!-- No [width] here on purpose: DevExtreme sizes the popup to match the editor's own
         rendered width when none is given, so the dropdown always lines up with the input
         field it belongs to instead of a fixed size that overflows narrow fields or leaves
         gaps next to wide ones. -->
    <!-- With the third column (Gesellschaften) it may grow beyond a narrow field, so "… erstellen" fits on one line. -->
    <dxo-drop-down-options [height]="'auto'" [minWidth]="societies ? threeColumnMinWidth : undefined">
    </dxo-drop-down-options>

    <div *dxTemplate="let data of 'content'" class="dropdown-panel">

      <div *ngIf="tagFilter" class="tag-filter-section">
        <dx-tag-box class="gpd-input" i18n-placeholder placeholder="Select Tag to Filter By"
          [(value)]="tagFilterValues" [searchEnabled]="true" displayExpr="title" valueExpr="id"
          acceptCustomValue="false" [items]="contactTags" [hideSelectedItems]="true"
          (onSelectionChanged)="filterContactsByTag($event)" [width]="'100%'">
        </dx-tag-box>
      </div>

      <div class="dropdown-columns">

        <!-- Persons column -->
        <div *ngIf="persons != undefined && persons != null && persons.length >= 1" class="dropdown-column">
          <div class="column-header">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"
              aria-hidden="true">
              <circle cx="12" cy="8" r="4" />
              <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" />
            </svg>
            <span i18n="persons">Persons</span>
          </div>
          <div class="new-contact-row" (click)="newContactRequested('person')">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"
              aria-hidden="true">
              <path d="M12 5v14M5 12h14"/>
            </svg>
            <span i18n="@@createPerson">Person erstellen</span>
          </div>
          <dx-data-grid #personGrid [dataSource]="persons" keyExpr="id" [height]="175"
            (onInitialized)="personGridOnInitialized($event)" [hoverStateEnabled]="true"
            (onRowClick)="handleContactSelected($event, 'person')" [pager]="{ visible: false }"
            [rowAlternationEnabled]="false" [showColumnHeaders]="false" [showBorders]="false"
            [showColumnLines]="false" [showRowLines]="false">
            <dxi-column dataField="displayName"></dxi-column>
          </dx-data-grid>
        </div>

        <div class="column-divider"></div>

        <!-- Companies column -->
        <div *ngIf="companies != undefined && companies != null && companies.length >= 1" class="dropdown-column">
          <div class="column-header">
            <img src="assets/icons/building.svg" width="20" height="20" aria-hidden="true" />
            <span i18n="@@companies">Companies</span>
          </div>
          <div class="new-contact-row" (click)="newContactRequested('company')">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"
              aria-hidden="true">
              <path d="M12 5v14M5 12h14"/>
            </svg>
            <span i18n="@@createCompany">Firma erstellen</span>
          </div>
          <dx-data-grid #companyGrid [dataSource]="companies" keyExpr="id" [height]="175"
            (onInitialized)="companyGridOnInitialized($event)" (onContentReady)="dataGridOnContentReady($event)"
            [hoverStateEnabled]="true" (onRowClick)="handleContactSelected($event, 'company')"
            [pager]="{ visible: false }" [rowAlternationEnabled]="false" [showColumnHeaders]="false"
            [showBorders]="false" [showColumnLines]="false" [showRowLines]="false">
            <dxi-column dataField="displayName"></dxi-column>
          </dx-data-grid>
        </div>

        <!-- Gesellschaften column: only where the caller passes them (shareholders of a
             Gesellschaft), also while there are none yet, so one can be created. -->
        <ng-container *ngIf="societies">
          <div class="column-divider"></div>
          <div class="dropdown-column">
            <div class="column-header">
              <app-svg-icon icon="hierarchy" [size]="20"></app-svg-icon>
              <span i18n="@@gesellschaften">Gesellschaften</span>
            </div>
            <div class="new-contact-row" (click)="newContactRequested('society')">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"
                aria-hidden="true">
                <path d="M12 5v14M5 12h14"/>
              </svg>
              <span i18n="@@createSociety">Gesellschaft erstellen</span>
            </div>
            <dx-data-grid #societyGrid [dataSource]="societies" keyExpr="id" [height]="175"
              (onInitialized)="societyGridOnInitialized($event)" [hoverStateEnabled]="true"
              (onRowClick)="handleContactSelected($event, 'society')" [pager]="{ visible: false }"
              [rowAlternationEnabled]="false" [showColumnHeaders]="false" [showBorders]="false"
              [showColumnLines]="false" [showRowLines]="false">
              <dxi-column dataField="displayName"></dxi-column>
            </dx-data-grid>
          </div>
        </ng-container>

      </div>
    </div>
  </dx-drop-down-box>
  <div *ngIf="errorText" class="gpd-field-error" role="alert">
    <app-svg-icon icon="alert" [color]="'var(--color-text-error)'" [size]="16"></app-svg-icon>
    <span>{{ errorText }}</span>
  </div>
</div>
